import { useDeptCategory } from "@root/hooks/useDeptCategory";
import React, { createContext, useContext, ReactNode } from "react";

const defaultState: any = {};

const DepartmentCateogryContext = createContext<any>(defaultState);

interface CategoryProviderProps {
  children: ReactNode;
}

export const DeptCategoryProvider: React.FC<CategoryProviderProps> = ({
  children,
}) => {
  const data = useDeptCategory();
  return (
    <DepartmentCateogryContext.Provider value={data}>
      {children}
    </DepartmentCateogryContext.Provider>
  );
};

export const useDeptCategoryContext = () => {
  return useContext(DepartmentCateogryContext);
};
